document.addEventListener("DOMContentLoaded", function () {

    if(window.innerWidth > 749) return;

    const sticky = document.querySelector(".aa-sticky-cart");

    const buyButtons = document.querySelector(".product-form");

    const addButton = document.querySelector(".product-form__submit");

    if(!sticky || !buyButtons || !addButton) return;

    const stickyButton = sticky.querySelector(".aa-sticky-cart__button");

    stickyButton.addEventListener("click",function(){

        addButton.click();

    });

    const observer = new IntersectionObserver(function(entries){

        entries.forEach(function(entry){

            if(entry.isIntersecting){

                sticky.classList.remove("show");

            }else{

                sticky.classList.add("show");

            }

        });

    },{

        threshold:.2

    });

    observer.observe(buyButtons);

});